import React from 'react'
import PropTypes from 'prop-types'
import PeopleIcon from '@material-ui/icons/People'
import SyncIcon from '@material-ui/icons/Sync'
import WarningIcon from '@material-ui/icons/Warning'
import FavoriteIcon from '@material-ui/icons/Favorite'
import { withStyles } from '@material-ui/core/styles'
import { computeSyncStats } from '../utils/syncStatus'
import StatCard from './ui/StatCard'

const styles = (theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2.5),
  },
})

function SyncSummary({ users, classes, avgHeart }) {
  const stats = computeSyncStats(users)
  const heartValue =
    avgHeart === null || avgHeart === undefined || avgHeart === '' || avgHeart === '無'
      ? '—'
      : `${avgHeart} bpm`

  return (
    <div className={classes.root}>
      <StatCard
        icon={<PeopleIcon />}
        label="群組內總人數"
        value={`${stats.total} 人`}
        color="#5b6cff"
        bg="#eef1ff"
      />
      <StatCard
        icon={<SyncIcon />}
        label="七天內已同步"
        value={`${stats.syncedWithin} 人（${stats.syncedWithinPct}%）`}
        color="#22c55e"
        bg="#dcfce7"
      />
      <StatCard
        icon={<WarningIcon />}
        label="超過七天未同步"
        value={`${stats.notSyncedOver} 人（${stats.notSyncedOverPct}%）`}
        color="#f59e0b"
        bg="#fef3c7"
      />
      <StatCard
        icon={<FavoriteIcon />}
        label="平均心率"
        value={heartValue}
        color="#ef4444"
        bg="#fee2e2"
      />
    </div>
  )
}

SyncSummary.propTypes = {
  users: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired,
  avgHeart: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default withStyles(styles)(SyncSummary)
